import React from "react";
import { Panel, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ArrowButton from "../../common/button-arrow";
import "./register-box.css";

const RegisterBox = () => {
  return (
    <Panel
      header={<h1 className="text-uppercase">Register</h1>}
      footer={
        <Link to={"/registration/outlet"}>
          <ArrowButton
            color="white"
            className="btn-block"
            arrow={false}
            submit={false}
          >
            Register now
          </ArrowButton>
        </Link>
      }
      className="login register-box"
      bsStyle="default"
    >
      <p className="p1">
        <strong>ignite</strong> is a partnership programme for tobacco retailers
        in Ireland to work in partnership with Imperial Brands John Player to
        grow their business. You can order stock, stay up to date with the
        latest category news and legislative information as well as be informed
        of any changes to our product portfolio and pricing.
      </p>
      <p className="p1">Everything you need just a click away.</p>
      <p>
        Registering for <strong>ignite</strong> is simple, all you need is your
        Customer Number and store Eircode. If you don't have this information,
        please contact your John Player Representative or use the Contact Us
        link at the bottom of this page.
      </p>
    </Panel>
  );
};

export default RegisterBox;



// WEBPACK FOOTER //
// ./src/components/login/register-box/index.jsx